import { render } from "./ObjetivoComisionList.vue?vue&type=template&id=ca0bab94&scoped=true"
import script from "./ObjetivoComisionList.vue?vue&type=script&lang=js"
export * from "./ObjetivoComisionList.vue?vue&type=script&lang=js"

import "./ObjetivoComisionList.vue?vue&type=style&index=0&id=ca0bab94&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0bab94"]])

export default __exports__